import axios from "axios";
import { PasswordResetData } from "../../api-types/sign-in";
import { PASSWORD_RESET_URL } from "../utils";

export const passwordReset = async (passwordResetData: PasswordResetData) => {
  return await axios.post(PASSWORD_RESET_URL, passwordResetData);
};
